import React from "react";
import { Box, Typography, FormControlLabel } from "@mui/material";

const RiskAnalysisHeader = ({ orgLoading, orgName, lang, setLang }) => (
  <Box
    className="risk-analysis-heading-row"
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    }}
  >
    <Typography className="risk-analysis-org-title">
      {orgLoading ? "Loading..." : orgName}
    </Typography>

    <Box className="risk-language-toggle">
      {["dk", "en"].map((l) => (
        <FormControlLabel
          key={l}
          control={
            <input
              type="radio"
              checked={lang === l}
              onChange={() => setLang(l)}
            />
          }
          label={l === "dk" ? "Danish" : "English"}
        />
      ))}
    </Box>
  </Box>
);

export default RiskAnalysisHeader;
